export const businessTypeList = [
  {
    'key': 'D',
    'value': 'D',
    'text': 'DISCAPACITADO',
  },
  {
    'key': 'O',
    'value': 'O',
    'text': 'DIPLOM/ONG',
  },
  {
    'key': 'C',
    'value': 'C',
    'text': 'INST. ESTADO',
  },
  {
    'key': 'P',
    'value': 'P',
    'text': 'CAMIONETA PRODUCTIVA',
  },
];
